export default [
	{
		path: '/pages/compliance/riskPrevention',
		meta: { title: '风险预防' },
		name: '/pages/compliance/riskPrevention',
		component: () => import('@/views/compliance/riskPrevention.vue'),
	},
];
